import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { WebStorageService, Scope } from '@mmortgage/common-utility';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'audit-request',
  templateUrl: './auditRequest.component.html',
  styleUrls: ['./auditRequest.component.less'], 
  providers: [FrameworkUtilityComponent] 
})
export class AuditRequestComponent implements OnInit {

  viewJson: any;
  type:boolean 

    constructor(private router : Router,private util: UtilService, private activatedRoute : ActivatedRoute){
    
    }
    ngOnInit(): void {
      if(localStorage.getItem('viewType') == "Response"){
        this.type = true
      }
      if(localStorage.getItem('viewType') == "Request"){
        this.type = false
      }
      this.viewJson = JSON.parse(localStorage.getItem('viewJson'))
    }

    gotoAuditPage(){
      this.router.navigate(['../view-audit-details'], { relativeTo: this.activatedRoute });

    }
}